import React from 'react';
import PropTypes from 'prop-types';

import Collapsible from '../../../../library/collapsible/collapsible';
import TagsSolidIcon from '../../../../shared/icons/tags-solid-icon';
import ProductLink from '../product-link/product-link';
import ProductLinkDealsHeader from '../product-link-deals-header/product-link-deals-header';

import {
  removeStoredBackToResultsUrl,
  setStoredBackToResultsUrl
} from '../../../../shared/utils/back-to-results/back-to-results';
import { isArrayWithLength } from '../../../../shared/utils/validators/validators';

import { BACK_TO_RESULTS_PAGE_IDS } from '../../../../shared/constants/back-to-results';

import './product-links.scss';

function ProductLinks(props) {
  const { category } = props;
  const { products } = category;

  if (!Array.isArray(products) || products.length === 0) {
    return null;
  }

  const collapsibleLabel = `${products.length} ${
    products.length === 1 ? 'model' : 'models'
  }`;

  const splitProductsByDeal =
    products
      ?.reduce(
        ([deals, nonDeals], product) => {
          if (product?.potentialPromotions?.length > 0)
            return [[...deals, product], nonDeals];
          else return [deals, [...nonDeals, product]];
        },
        [[], []]
      )
      .reverse() || [];

  function setUrl() {
    removeStoredBackToResultsUrl();
    setStoredBackToResultsUrl(BACK_TO_RESULTS_PAGE_IDS.CATEGORY);
  }

  return (
    <div styleName="container">
      <Collapsible
        className="collapsible"
        collapseType="SECONDARY"
        isOpenByDefault
        label={collapsibleLabel}
      >
        <ul styleName="model-list">
          {splitProductsByDeal.map(
            (products, idx) =>
              isArrayWithLength(products) && (
                <li key={idx} styleName="model-list-item">
                  {isArrayWithLength(splitProductsByDeal[0]) && idx === 1 && (
                    <ProductLinkDealsHeader
                      category={category}
                      onClick={setUrl}
                    />
                  )}

                  {products.map(product => {
                    const { code } = product;

                    return (
                      <ProductLink
                        key={code}
                        onClick={setUrl}
                        product={product}
                        renderIcon={
                          idx === 1 ? <TagsSolidIcon styleName="promo" /> : null
                        }
                      />
                    );
                  })}
                </li>
              )
          )}
        </ul>
      </Collapsible>
    </div>
  );
}

ProductLinks.propTypes = {
  category: PropTypes.shape({
    products: PropTypes.arrayOf(
      PropTypes.shape({
        code: PropTypes.string,
        potentialPromotions: PropTypes.array
      })
    )
  })
};

export default ProductLinks;
